import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';

import { dateHeader, formatCellDate } from './timeModeCell';
import { Tooltip } from '@mui/material';

export const makeDeviceTypeSettingColumn = (onEdit: (data: any) => void) => {
  const col = [
    {
      id: 'id',
      header: '',
      accessorKey: 'id',
      size: 60,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        const handleEdit = () => {
          onEdit(row.original);
        };
        return (
          <Tooltip id={row.original.id} title='Edit' disableInteractive style={{ cursor: 'pointer' }} onClick={handleEdit}>
            <EditNoteRoundedIcon fontSize='small' />
          </Tooltip>
        );
      },
    },
    {
      header: 'Device Name',
      accessorKey: 'name',
      enableColumnFilter: true,
      size: 170,
    },
    {
      header: 'Device Type',
      accessorKey: 'type',
      enableColumnFilter: true,
      size: 180,
    },
    {
      header: 'Max Age in days',
      sortable: false,
      enableColumnFilter: false,
      size: 150,
      cell: ({ row }) => row.original?.settings?.isHealthy_MaxAgeInDays,
    },
    {
      header: 'Max days since last sighting',
      sortable: false,
      enableColumnFilter: false,
      size: 200,
      cell: ({ row }) => row.original?.settings?.isHealthy_MaxDaysSinceLastSighting,
    },
    {
      header: 'Min Battery Voltage',
      sortable: false,
      enableColumnFilter: false,
      size: 160,
      cell: ({ row }) => row.original?.settings?.isHealthy_MinBatteryVoltage,
    },
    {
      header: 'Manufacturer',
      accessorKey: 'manufacturer',
      enableColumnFilter: true,
      size: 160,
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.modifiedDateTime),
    },
  ] as Array<any>;

  return col;
};
